import React, { useEffect, useRef, forwardRef } from "react"
import * as THREE from "three"
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js"
import styled from "styled-components"

const StyledPartsIcon = styled.div`
  flex: 0 0 calc(100% / var(--items-per-screen));
  width: calc(100% / var(--items-per-screen));
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  & > p {
    background-color: transparent;
    margin: 0;
    position: absolute;
    font-size: 0.62rem;
    color: black;
    transition: color 250ms;
    // &:hover {
    //   background-color: transparent;
    // }
  }
  & > canvas {
    top: 0;
    left: 0;
    z-index: 0;
    width: 80%;
    aspect-ratio: 16 / 9;
    background-color: rgba(128, 128, 128, 0.2);
    opacity: 0.5;
  }
  :hover {
    cursor: pointer;
    background-color: rgba(128, 128, 128, 0.95);
    transition: background-color 0.5s;
    & > p {
      color: white;
    }
  }
`
const PartsIcon = (props) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    if (!props.visible) {
      return
    }
    if (!canvasRef.current) return

    // Scene
    const scene = new THREE.Scene()
    scene.background = new THREE.Color(0xffffff)

    // AmbientLight
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3)
    scene.add(ambientLight)

    // HemisphereLight
    const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x000000, 0.5)
    scene.add(hemisphereLight)

    // PerspectiveCamera
    const camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    )
    camera.position.set(0, 0, 0.5)

    // WebGLRenderer
    const renderer = new THREE.WebGLRenderer({
      canvas: canvasRef.current,
      antialias: true,
    })
    // renderer.setSize(100, 100)

    if (!props.visible) {
      renderer.dispose()
    } else {
      // GLTFLoader
      const loader = new GLTFLoader()

      loader.load(props.path, (gltf) => {
        if (gltf.scene) {
          // モデルのバウンディングボックスを計算
          const boundingBox = new THREE.Box3().setFromObject(gltf.scene)
          const center = boundingBox.getCenter(new THREE.Vector3())
          const size = boundingBox.getSize(new THREE.Vector3())

          // カメラの位置を調整して、モデルの中心に合わせる
          camera.position.set(center.x, center.y, size.length())
          camera.lookAt(center)

          // カメラの位置をモデルが完全に表示されるように調整
          // const maxDim = Math.max(size.x, size.y, size.z)
          // const fov = camera.fov * (Math.PI / 180)
          // let cameraZ = Math.abs((maxDim / 2) * Math.tan(fov * 2))
          // cameraZ *= 1.1 // サイズに少し余裕を持たせるためのマルチプライヤ
          // camera.position.z = cameraZ

          // const minZ = boundingBox.min.z
          // const cameraToFarEdge = minZ < 0 ? -minZ + cameraZ : cameraZ - minZ

          // camera.far = cameraToFarEdge * 3
          // camera.updateProjectionMatrix()
          scene.add(gltf.scene)
          renderer.render(scene, camera)
        }
      })
    }
  }, [props.path, props.visible])

  return props.visible ? (
    <StyledPartsIcon onClick={props.onClick}>
      <p>{props.label}</p>
      {/* <canvas ref={canvasRef} /> */}
      <canvas />
    </StyledPartsIcon>
  ) : (
    <StyledPartsIcon></StyledPartsIcon>
  )
}

export default PartsIcon
